import React from 'react';
import './styles.css';
export default function Button(_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, onClick = _a.onClick, _g = _a.type, type = _g === void 0 ? 'button' : _g, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.origin, origin = _j === void 0 ? 'spp' : _j, dataTestId = _a["data-testid"];
    var baseClasses = [
        'material-button',
        "material-button--".concat(variant),
        "material-button--".concat(color),
        "material-button--".concat(size),
        fullWidth ? 'material-button--full-width' : '',
        disabled ? 'material-button--disabled' : '',
        origin === 'oncall' ? "on-call-button on-call-button--".concat(color) : '',
        className,
    ].filter(Boolean).join(' ');
    return (React.createElement("button", { type: type === 'submit' ? 'submit' : 'button', className: baseClasses, onClick: onClick, disabled: disabled, "data-testid": dataTestId },
        React.createElement("span", { className: "material-button__label" }, children)));
}
//# sourceMappingURL=Button.js.map